module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subComponent"
  }, [_c('el-dialog', {
    attrs: {
      "title": "新增认证",
      "visible": _vm.openstate,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.openstate = $event
      },
      "open": _vm.openHandle,
      "closed": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "cbody"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("主体类型")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "ztlx",
      "selectId": _vm.params.subjectTypeId,
      "plaText": "主体类型",
      "paramsKey": "subjectType"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("身份类别")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('dic-select', {
    attrs: {
      "code": "sflx",
      "selectId": _vm.params.identityTypeId,
      "plaText": "身份类型",
      "paramsKey": "identityType"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("管理员")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "source"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "270px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "size": "medium",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.adminChange
    },
    model: {
      value: (_vm.adminId),
      callback: function($$v) {
        _vm.adminId = $$v
      },
      expression: "adminId"
    }
  }, _vm._l((_vm.seekArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.realName,
        "value": item.id
      }
    }, [_c('div', [_vm._v("\n                                 " + _vm._s(_vm._f("transPhone")(item.cellPhone)) + "\n                                 "), _c('span', {
      staticStyle: {
        "color": "#999999",
        "margin-left": "3px"
      }
    }, [_vm._v(_vm._s(item.realName))])])])
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("有效证件")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('firmUpload', {
    on: {
      "imgChange": _vm.imgHandle1
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("认证公函")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('firmUpload', {
    on: {
      "imgChange": _vm.imgHandle2
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.openstate = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.goSubAdd
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-6403527c"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/enterpriseMent/src/cModel.vue
// module id = 1509
// module chunks = 1